export default __webpack_public_path__ + "files/ae5bb38e37a452ff91c89da9bdb7c589.mp3";